import { render, staticRenderFns } from "./input-boolean.vue?vue&type=template&id=67431f3a&"
import script from "./input-boolean.component.ts?vue&type=script&lang=ts&"
export * from "./input-boolean.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports